import YICUClassPage from "./YICUClassPage";

const CONTENT = {
  winnerPhotos: [
    { src: "/images/YICU/2022/2022-YICU-Winners.png", caption: "13 Recipients of 2022 YICU Service Awards — Sonika Tamilarasan, Lauren Cutler, Bradley Ross Jackson, Morgan Mouser, Anusha Nadkarni, Shloka Ravinuthala, Shrikar Chennuru, Claire Campbell, Willie Holton Halbert, River Stokes Dorsey, Hasna Mohamed Jamal, Manu Gadhiraju" },
    { src: "/images/YICU/2022/2022-YICU-Nominees.png", caption: "2022 YICU Nominees — Claire Campbell, Brooklyn Symone Caffey, Reilley Owens, Hasna Mohamed Jamal, Manu Gadhiraju, Lauren Monk, Amaya Hursey, Garrick Dickerson, Morgan Mouser, Kamaya Coleman, Anusha Nadkarni, River Stokes Dorsey, Shloka Ravinuthala, Lauren Cutler, Siddhi Hindurao, Sonika Tamilarasan, Shrikar Chennuru, Sristi Ganta" },
  ],
  winners: [
    { label: "2022 YICU Winners (13 Recipients)", color: "pink", items: ["Sonika Tamilarasan", "Lauren Cutler", "Bradley Ross Jackson", "Morgan Mouser", "Anusha Nadkarni", "Shloka Ravinuthala", "Shrikar Chennuru", "Claire Campbell", "Willie Holton Halbert", "River Stokes Dorsey", "Hasna Mohamed Jamal", "Manu Gadhiraju"] },
  ],
  nomineeList: [
    "Claire Campbell", "Brooklyn Symone Caffey", "Reilley Owens", "Hasna Mohamed Jamal", "Manu Gadhiraju",
    "Lauren Monk", "Amaya Hursey", "Garrick Dickerson", "Morgan Mouser", "Kamaya Coleman", "Anusha Nadkarni",
    "River Stokes Dorsey", "Shloka Ravinuthala", "Lauren Cutler", "Siddhi Hindurao", "Sonika Tamilarasan",
    "Shrikar Chennuru", "Sristi Ganta",
  ],
};

export default function Yicu2022() {
  return <YICUClassPage year="2022" logoSrc="/images/YICU/2022/YICU2022.png" content={CONTENT} />;
}